import { Component, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { DocAdicionalService } from 'src/app/services/doc-adicional.service';
import { DocumentoService } from 'src/app/services/documento.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {

  documentos:any = []
  documentoAdic:any = []


  constructor(private apollo: Apollo, private documentoService: DocumentoService, private docAdicService: DocAdicionalService) { }

  ngOnInit(): void {
    this.getAllDocumentosSinValidar()
    this.getAllDocumentosAdicionalesSinValidar()
  }

  getAllDocumentosSinValidar(){
    this.apollo.watchQuery<any>({
      query: this.documentoService.getAllDocumentosSinValidar(),
      fetchPolicy: 'no-cache',
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {

        this.documentos = data.documentos
        this.documentos = this.documentos.length
  
      })
  }

  getAllDocumentosAdicionalesSinValidar(){
    this.apollo.watchQuery<any>({
      query: this.docAdicService.getAllDocumentosSinValidar(),
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data);
        
        this.documentoAdic = data.documentosAdicionals
        this.documentoAdic = this.documentoAdic.length
      })
  }

}
